<template>
    <div>
            <a-divider orientation="left">{{ t('tenant.tenantInfo') }}</a-divider>
            <a-descriptions :column="3" size="small" class="desc_row">
                    <a-descriptions-item 
                        v-for="(item,index) in tenant_arr" 
                        :key="index" 
                        :label="item.label"
                    >
                        <span class="key_value" v-if="item.key !== 'logo_icon' && item.key !== 'small_logo_icon'">{{ item.value }} </span>
                        <a-image :src="item.value" v-else-if="item.key === 'logo_icon'" class="logo_img" :width="60"/>
                        <a-image :src="item.value" v-else-if="item.key === 'small_logo_icon'" class="logo_img" :width="30"/>
                    </a-descriptions-item>
            </a-descriptions>

            <a-divider orientation="left">{{ t('tenant.mailInfo') }}</a-divider>
            <a-descriptions :column="3" size="small" class="desc_row">
                    <a-descriptions-item 
                        v-for="(item,index) in tenant_mail_arr" 
                        :key="index" 
                        :label="item.label"
                    >
                        <span class="key_value" v-if="item.key !== 'mail_head_icon' && item.key !== 'mail_footer_icon'">{{ item.value }} </span>
                        <a-image :src="item.value" v-else class="logo_img" :width="60"/>
                    </a-descriptions-item>
            </a-descriptions>

            <a-divider orientation="left">{{ t('tenant.partPermission') }}</a-divider>
            <a-descriptions :column="3" size="small" class="desc_row">
                    <a-descriptions-item 
                        v-for="(item,index) in tenant_part_permission_arr" 
                        :key="index" 
                        :label="item.label"
                    >{{ item.value }}</a-descriptions-item>
            </a-descriptions>

            <a-divider orientation="left">{{ t('tenant.policies') }}</a-divider>
            <a-table 
                :dataSource="tenant_policies_arr" 
                :columns="tenant_policies_columns" 
                :pagination="false"
            />
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, watch } from "vue";
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { TenantApi } from '@/api/TenantApi.js';
    import { getWeek } from '@/hooks/useGetWeek';
    import { formatTimestamp, debounce } from '@/utils/global';

    const { t } = useI18n()

    const props = defineProps({
        detailData:{
            type:Object,
            default:()=>{},
        },
    })

    console.log(props.detailData, 'props.detailData')

    const infoData = reactive({
        tenant:{
            tenant_name:'',
            tenant_code:'',
            app_id:'',
            domain_name:'',
            project_no:'',
            // jwt_secret:'',
            picture_path:'',
            file_path:'',
            avatar_path:'',
            vali_user_path:'',
            firmware_path:'',
            del_user_path:'',
            fault_path:'',
            fault_font_color:'',
            fault_background_color:'',
            activate_mileage_type:'',
            warranty_period:'',
            logo_icon:'',
            small_logo_icon:'',
        },
        tenant_mail:{
            mail_host:'',
            mail_port:'',
            mail_protocol:'',
            mail_username:'',
            // mail_password:'',
            default_encoding:'',
            mail_debug:'',
            mail_starttls:'',
            mail_ssl:'',
            mail_auth:'',
            mail_head_icon:'',
            mail_footer_icon:'',
        },
        tenant_part_permission:{
            require_hardware_version:'',
            require_software_version:'',
            require_company_id:'',
            require_project_no:'',
            check_display_theft_prevention:'',
            check_motor_bit:'',
            check_motor_bind_status:'',
            triple_id_trans_frame_number:'',
            require_new_motor_key:'',
        },
        tenant_policies:[
            {
                locale_language: '',
                home_path: '',
                support_path: '',
                assemble_path: '',
                privacy_path: '',
                warranty_path: '',
                fault_can_footer: '',
            }
        ],
    })

    const tenant_arr = ref([])
    const tenant_mail_arr = ref([])
    const tenant_part_permission_arr = ref([])
    const tenant_policies_arr = ref([])
    const tenant_policies_columns = ref([
        {
            title: t('tenant.locale_language'),
            key: 'locale_language',
            dataIndex: 'locale_language',
        },
        {
            title: t('tenant.home_path'),
            key: 'home_path',
            dataIndex: 'home_path',
            ellipsis: true,
        },
        {
            title: t('tenant.support_path'),
            key: 'support_path',
            dataIndex: 'support_path',
            ellipsis: true,
        },
        {
            title: t('tenant.assemble_path'),
            key: 'assemble_path',
            dataIndex: 'assemble_path',
            ellipsis: true,
        },
        {
            title: t('tenant.privacy_path'),
            key: 'privacy_path',
            dataIndex: 'privacy_path',
            ellipsis: true,
        },
        {
            title: t('tenant.warranty_path'),
            key: 'warranty_path',
            dataIndex: 'warranty_path',
            ellipsis: true,
        },
        {
            title: t('tenant.fault_can_footer'),
            key: 'fault_can_footer',
            dataIndex: 'fault_can_footer',
            ellipsis: true,
        },
    ])
   

    const init = ()=>{
        tenant_arr.value = []
        tenant_mail_arr.value = []
        tenant_part_permission_arr.value = []
        tenant_policies_arr.value = []

        for(let key in infoData.tenant){
            tenant_arr.value.push({
                label: t('tenant.' + key),
                value: props.detailData.tenant[key],
                key: key,
            })
        }

        for(let key in infoData.tenant_mail){
            tenant_mail_arr.value.push({
                label: t('tenant.' + key),
                value: props.detailData.tenant_mail[key] == 0? t('base.yes') : props.detailData.tenant_mail[key] == 1? t('base.no') : props.detailData.tenant_mail[key],
                key: key,
            })
        }

        for(let key in infoData.tenant_part_permission){
            tenant_part_permission_arr.value.push({
                label: t('tenant.' + key),
                value: props.detailData.tenant_part_permission[key] == 0? t('base.yes') : t('base.no'),
                key: key,
            })
        }

        props.detailData.tenant_policies.forEach(item => {
            tenant_policies_arr.value.push({
                locale_language: item.locale_language,
                home_path: item.home_path,
                support_path: item.support_path,
                assemble_path: item.assemble_path,
                privacy_path: item.privacy_path,
                warranty_path: item.warranty_path,
                fault_can_footer: item.fault_can_footer,
            })
        })

        console.log(tenant_arr.value, 'tenant_arr.value')
        console.log(tenant_mail_arr.value, 'tenant_mail_arr.value')
        console.log(tenant_part_permission_arr.value, 'tenant_part_permission_arr.value')
        console.log(props.detailData.tenant_policies, 'tenant_policies')
    }
    
    watch(()=>props.detailData,(val)=>{
        console.log(val,'hhhhhhhh')
        init()
    })

    onMounted(()=>{
        init()
    })

</script>

<style lang="scss" scoped>
.desc_row{
    margin-bottom: 30px;
}

::v-deep .ant-descriptions .ant-descriptions-item-label,
::v-deep .ant-descriptions .ant-descriptions-item-content{
    font-size:11px;
}

::v-deep .ant-descriptions .ant-descriptions-item-label{
    width: 200px;
    font-weight: bold;
}

::v-deep .ant-descriptions-small .ant-descriptions-row >th, 
::v-deep .ant-descriptions-small .ant-descriptions-row >td{
    padding-bottom: 4px;
}

.ant-descriptions .ant-descriptions-header{
    margin-bottom: 10px;
}
</style>